// Unit converters - deterministic, factor-based
// Each converter: convert(value, fromUnit, toUnit) => number

const F = {
  length: {
    base: "m",
    units: {
      ft: { name: "Feet", factor: 0.3048 },
      m: { name: "Meters", factor: 1 },
      in: { name: "Inches", factor: 0.0254 },
      mm: { name: "Millimeters", factor: 0.001 },
    },
  },
  pressure: {
    base: "kPa",
    units: {
      psi: { name: "PSI", factor: 6.894757 },
      bar: { name: "Bar", factor: 100 },
      kPa: { name: "kPa", factor: 1 },
      MPa: { name: "MPa", factor: 1000 },
    },
  },
  volume: {
    base: "L",
    units: {
      bbl: { name: "Barrels (US oil)", factor: 158.987 },
      gal: { name: "Gallons (US)", factor: 3.7854 },
      m3: { name: "Cubic Meters", factor: 1000 },
      L: { name: "Litres", factor: 1 },
    },
  },
  density: {
    // custom - using ppg as base
    base: "ppg",
    units: {
      ppg: { name: "ppg (lb/gal US)" },
      sg: { name: "Specific Gravity" },
      kgm3: { name: "kg/m³" },
    },
  },
  flow: {
    base: "L/min",
    units: {
      gpm: { name: "Gallons/min (US)", factor: 3.7854 },
      bpm: { name: "Barrels/min", factor: 158.987 },
      lpm: { name: "Litres/min", factor: 1 },
    },
  },
  temp: {
    base: "C",
    units: {
      F: { name: "Fahrenheit" },
      C: { name: "Celsius" },
    },
  },
};

export const CONVERTER_GROUPS = F;

export function convert(group, value, from, to) {
  const g = F[group];
  if (!g) throw new Error("Unknown group");
  const v = Number(value);
  if (Number.isNaN(v)) throw new Error("Invalid value");
  if (group === "temp") {
    let c;
    if (from === "C") c = v;
    else if (from === "F") c = (v - 32) * 5 / 9;
    else throw new Error("Bad temp unit");
    if (to === "C") return c;
    if (to === "F") return c * 9 / 5 + 32;
    throw new Error("Bad temp unit");
  }
  if (group === "density") {
    // base ppg
    let ppg;
    if (from === "ppg") ppg = v;
    else if (from === "sg") ppg = v * 8.345;
    else if (from === "kgm3") ppg = v / 119.826;
    else throw new Error("Bad density unit");
    if (to === "ppg") return ppg;
    if (to === "sg") return ppg / 8.345;
    if (to === "kgm3") return ppg * 119.826;
    throw new Error("Bad density unit");
  }
  const ff = g.units[from];
  const tf = g.units[to];
  if (!ff || !tf) throw new Error("Bad unit");
  const baseVal = v * ff.factor;
  return baseVal / tf.factor;
}

export function formatNumber(n, digits = 6) {
  if (!isFinite(n)) return String(n);
  // trim trailing zeros while keeping precision
  const fixed = Number(n).toFixed(digits);
  return parseFloat(fixed).toString();
}
